import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import Api from "@services/Api";
import { toastError } from "@utils/functions";
import { Company, SellerData } from "@utils/types";
import store from "./index";

const company = createSlice({
  name: "company",
  initialState: {
    loading: true,
    loadingSeller: true,
    data: {} as Company,
    seller: {} as SellerData,
  },
  reducers: {
    setLoadingCompany(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCompany(state, action: PayloadAction<Company>) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompany.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCompany.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchCompanyMaintenanceMode.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCompanyMaintenanceMode.fulfilled, (state, action) => {
      state.data.is_maintenance_mode_enabled = action.payload.is_maintenance_mode_enabled;
      state.loading = false;
    });
    builder.addCase(fetchSeller.pending, (state, action) => {
      state.loadingSeller = true;
    });
    builder.addCase(fetchSeller.fulfilled, (state, action) => {
      state.seller = action.payload;
      state.loadingSeller = false;
    });
  },
});

export default company.reducer;

export const { setLoadingCompany, setCompany } = company.actions;

export const fetchCompany = createAsyncThunk("company/fetchCompany", async (companyCode: string) => {
  try {
    const { data } = await Api.get(`/company/by_code/${companyCode}`);
    return data.company;
  } catch (error) {
    console.log(error, "error on fetchCompany()");
    toastError(error);
  }
});
export const fetchCompanyMaintenanceMode = createAsyncThunk("company/fetchCompanyMaintenanceMode", async (companyCode: string) => {
  try {
    const { data } = await Api.get(`/company/by_code/${companyCode}/is_maintenance_mode_enabled`);
    return data;
  } catch (error) {
    console.log(error, "error on fetchCompanyMaintenanceMode()");
    toastError(error);
  }
});

export const fetchSeller = createAsyncThunk("company/fetchSeller", async (sellerId: string) => {
  const state = store.getState();
  try {
    // We can be confident accessing company.data.id here because this method is only called after fetchCompany has been dispatched
    const { data } = await Api.get(`/company/${state.company.data.id}/seller/${sellerId}`);
    return data.seller;
  } catch (error: any) {
    console.log(error, "error on fetchSeller()");
    if (error.response?.data?.message === "seller-not-found") {
      localStorage.setItem(`company_${state.company.data.code}_seller_id`, "");
    } else {
      toastError(error);
    }
  }
});
